mutation RestoreBroadcast($id: ID!) {
    campaignRestore(input: {id: $id}) {
        campaign {
            id
        }
    }
}
